import React from 'react';
import { useNavigate } from 'react-router-dom';

const TermsOfService = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-black text-white py-12 px-6">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <button 
            onClick={() => navigate('/')}
            className="mb-4 text-[#54edb6] hover:text-white transition-colors"
          >
            ← Back to Home
          </button>
          <h1 className="text-4xl font-bold mb-4">Terms of Service</h1>
          <p className="text-gray-400">Last updated: December 2024</p>
        </div>

        {/* Content */}
        <div className="prose prose-invert max-w-none space-y-6">
          
          <section>
            <h2 className="text-2xl font-semibold text-[#54edb6] mb-4">1. Acceptance of Terms</h2>
            <p className="text-gray-300 leading-relaxed">
              By accessing and using Immigrantvli.com ("the Service"), you accept and agree to be bound by the terms and provision of this agreement. 
              If you do not agree to abide by the above, please do not use this service.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-[#54edb6] mb-4">2. Description of Service</h2>
            <p className="text-gray-300 leading-relaxed">
              Immigrantvli.com provides AI-powered immigration document analysis, case review, and document preparation services. 
              Our platform offers various immigration-related tools and agents to assist users with their immigration processes.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-[#54edb6] mb-4">3. Legal Disclaimer</h2>
            <p className="text-gray-300 leading-relaxed">
              <strong>IMPORTANT:</strong> Immigrantvli.com does not provide legal advice and is not a substitute for an attorney. 
              The information and services provided are for informational purposes only. Users should consult with a qualified 
              immigration attorney for legal advice specific to their situation.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-[#54edb6] mb-4">4. User Responsibilities</h2>
            <p className="text-gray-300 leading-relaxed mb-3">Users agree to:</p>
            <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
              <li>Provide accurate and truthful information</li>
              <li>Use the service for lawful purposes only</li>
              <li>Not share account credentials with third parties</li>
              <li>Comply with all applicable laws and regulations</li>
              <li>Respect the intellectual property rights of the platform</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-[#54edb6] mb-4">5. Privacy and Data Protection</h2>
            <p className="text-gray-300 leading-relaxed">
              We take your privacy seriously. Please review our Privacy Policy to understand how we collect, 
              use, and protect your personal information. By using our service, you consent to the collection 
              and use of information in accordance with our Privacy Policy.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-[#54edb6] mb-4">6. Subscription and Payment Terms</h2>
            <p className="text-gray-300 leading-relaxed mb-3">
              Immigrantvli.com offers both free and paid subscription plans. Paid subscriptions include:
            </p>
            <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
              <li>Monthly recurring billing</li>
              <li>Automatic renewal unless cancelled</li>
              <li>Usage limits based on subscription tier</li>
              <li>Access to premium features and additional AI agents</li>
            </ul>
            <p className="text-gray-300 leading-relaxed mt-3">
              Users may cancel their subscription at any time through their account settings or by contacting support.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-[#54edb6] mb-4">7. Limitation of Liability</h2>
            <p className="text-gray-300 leading-relaxed">
              Immigrantvli.com and its affiliates shall not be liable for any indirect, incidental, special, 
              consequential, or punitive damages, including but not limited to loss of profits, data, use, 
              goodwill, or other intangible losses resulting from your use of the service.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-[#54edb6] mb-4">8. Intellectual Property</h2>
            <p className="text-gray-300 leading-relaxed">
              The service and its original content, features, and functionality are and will remain the exclusive 
              property of Immigrantvli.com and its licensors. The service is protected by copyright, trademark, 
              and other laws.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-[#54edb6] mb-4">9. Termination</h2>
            <p className="text-gray-300 leading-relaxed">
              We may terminate or suspend your access immediately, without prior notice or liability, 
              for any reason whatsoever, including without limitation if you breach the Terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-[#54edb6] mb-4">10. Changes to Terms</h2>
            <p className="text-gray-300 leading-relaxed">
              We reserve the right, at our sole discretion, to modify or replace these Terms at any time. 
              If a revision is material, we will try to provide at least 30 days notice prior to any new terms taking effect.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-[#54edb6] mb-4">11. Contact Information</h2>
            <p className="text-gray-300 leading-relaxed">
              If you have any questions about these Terms of Service, please contact us at:
            </p>
            <div className="bg-gray-900 p-4 rounded-lg mt-4">
              <p className="text-[#54edb6] font-semibold">Email: info@immigrantvli.com</p>
              <p className="text-gray-300">Address: 10 Glenlake Pkwy NE, Atlanta, GA 30328</p>
            </div>
          </section>

        </div>
      </div>
    </div>
  );
};

export default TermsOfService;